/**
 * Sales Admin sidebar.
 *
 * Identical to the sales supervisor's menu plus the Attendance — Hours report,
 * which the backend locks to the user's own branch (the Tamil Nadu sales admin
 * sits on the Coimbatore branch, so they only ever see Coimbatore punches).
 * Kept as its own file rather than shared with sales_supervisor, which has no
 * attendance access.
 */
export const SALES_ADMIN_SIDEBAR = [
  { slug: 'title', name: 'Home' },
  { slug: 'link', name: 'Dashboard', href: '/dashboard', icon: 'cilSpeedometer' },

  { slug: 'title', name: 'Sales' },
  { slug: 'link', name: 'Tele Sales', href: '/telesales', icon: 'cilPhone' },
  { slug: 'link', name: 'Order Form', href: '/orderform', icon: 'cilPencil' },
  { slug: 'link', name: 'POS', href: '/pos', icon: 'cilCalculator' },
  { slug: 'link', name: 'Orders', href: '/orders', icon: 'cilBox' },

  { slug: 'title', name: 'Operations' },
  { slug: 'link', name: 'Graded Follow Ups', href: '/grade_followups', icon: 'cilStar' },
  { slug: 'link', name: 'Refunds', href: '/refund', icon: 'cilMoneyBack' },
  { slug: 'link', name: 'Mark Returns', href: '/shipping/returns', icon: 'cilRefund' },
  { slug: 'link', name: 'Barcodes', href: '/barcodes', icon: 'cilBarcode' },
  {
    slug: 'link',
    name: 'Branch Attendance',
    href: '/attendance/hours',
    icon: 'cilClock',
    permission: 'view_attendance',
  },

  {
    slug: 'dropdown',
    name: 'Reports',
    icon: 'cilReport',
    elements: [
      { slug: 'link', name: 'Sales Report', href: '/salesreport', icon: 'cilChartUp' },
      { slug: 'link', name: 'POS Sales', href: '/pos-sales', icon: 'cilReceipt' },
      { slug: 'link', name: 'Department Report', href: '/departmentreport', icon: 'cilGrid' },
      { slug: 'link', name: 'Branch Report', href: '/branchreport', icon: 'cilChartLine' },
      { slug: 'link', name: 'Agentwise Report', href: '/agentwise_report', icon: 'cilUserChart' },
      { slug: 'link', name: 'Telesales Report', href: '/telesales_report', icon: 'cilPhoneChart' },
      { slug: 'link', name: 'Download Reports', href: '/reports', icon: 'cilCloudDownload' },
    ],
  },
]
